import React from 'react';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire AddToCart pixel event for Shopify cart links
    if (props.href?.includes('thealphamethods.com/cart')) {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToCart', {
          content_name: 'El Escudo del Hogar Cristiano',
          content_type: 'product',
          value: 6.36,
          currency: 'USD'
        });
      }
    }
    if (onClick) onClick(e);
  };
  return <a {...props} onClick={handleClick} className={`
        inline-flex items-center justify-center px-8 py-4 
        bg-gold-500 text-white font-serif font-semibold text-lg md:text-xl
        rounded-sm shadow-md hover:bg-gold-600 hover:shadow-lg
        transition-all duration-300 ease-out transform hover:-translate-y-1
        text-center tracking-wide
        ${className}
      `} data-id="element-15">
      {children}
    </a>;
}